"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TOOLTIP_OPENED_EVENT_NAME = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _get = _interopRequireDefault(require("lodash/get"));
var _env = _interopRequireDefault(require("../../utils/env/env"));
var _Help32PxOutlined = _interopRequireDefault(require("../../elements/icons-jb/Help32PxOutlined"));
var _staticContentPropCheck = _interopRequireDefault(require("../../utils/content/staticContentPropCheck"));
var _detectTouchPoint = _interopRequireDefault(require("../../utils/touch/detectTouchPoint"));
var _tooltipModule = _interopRequireDefault(require("./tooltip.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TOOLTIP_OPENED_EVENT_NAME = exports.TOOLTIP_OPENED_EVENT_NAME = 'jl-ui-kit.tooltip.opened';
var Tooltip = /*#__PURE__*/function (_PureComponent) {
  _inherits(Tooltip, _PureComponent);
  function Tooltip(props) {
    var _this;
    _classCallCheck(this, Tooltip);
    _this = _callSuper(this, Tooltip, [props]);
    _defineProperty(_assertThisInitialized(_this), "onOpen", function (event) {
      _this.setState({
        contentOpen: event.detail.id === _this.props.id
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onButtonTouchStart", function () {
      _this.setState({
        scrollStartPosition: window.scrollY
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onButtonTouchEnd", function (evt) {
      evt.preventDefault();
      var scrollEndPosition = window.scrollY;

      // check intended button click
      if (!(scrollEndPosition > _this.state.scrollStartPosition + 5)) {
        // toggle close
        if (_this.state.contentOpen) {
          _this.closeTooltip(true);
          return;
        }
        _this.openTooltip();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onPopOverClose", function (e) {
      var _e$currentTarget$data;
      var tooltipClosedManually = ((_e$currentTarget$data = e.currentTarget.dataset) === null || _e$currentTarget$data === void 0 ? void 0 : _e$currentTarget$data.test) === 'tooltip-popover-close-button';
      _this.closeTooltip(tooltipClosedManually);
    });
    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      var contentOpen = _this.state.contentOpen;
      if (contentOpen) {
        _this.closeTooltip(true);
      } else {
        _this.openTooltip();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "intersectionObserverCallback", function (entries) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio !== 1 && _this.state.contentOpen) {
          _this.setState({
            contentOpen: false
          });
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "initIntersectionObserver", function () {
      /* close tooltip when it gets scrolled out of view */
      if (_this.tooltip && _this.tooltip.current) {
        var observer = new IntersectionObserver(_this.intersectionObserverCallback, {
          threshold: 1
        });
        observer.observe(_this.tooltip.current);
        _this.observer = observer;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "removeIntersectionObserver", function () {
      if (_this.observer && _this.tooltip && _this.tooltip.current) {
        _this.observer.unobserve(_this.tooltip.current);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "closeTooltip", function () {
      var tooltipClosedManually = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var contentOpen = _this.state.contentOpen;
      if (!contentOpen) return;
      _this.setState({
        contentOpen: false
      }, function () {
        _this.props.onClose(tooltipClosedManually);
      });
      if (_env["default"].isClient) {
        window.removeEventListener('click', _this.windowClickListener);
        window.removeEventListener('keydown', _this.windowEscapeListener);
        if ((0, _get["default"])(_assertThisInitialized(_this), 'tooltip.current.querySelector')) {
          var launchButton = _this.tooltip.current.querySelector('button');
          if (launchButton && launchButton.focus) {
            launchButton.focus();
          }
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "openTooltip", function () {
      _this.setState({
        contentOpen: true
      });
      if (_env["default"].isClient) {
        window.addEventListener('click', _this.windowClickListener);
        window.addEventListener('keydown', _this.windowEscapeListener);
        window.dispatchEvent(new CustomEvent(TOOLTIP_OPENED_EVENT_NAME, {
          detail: {
            id: _this.props.id
          }
        }));
      }
    });
    _defineProperty(_assertThisInitialized(_this), "positionTooltipPopover", function () {
      var defaultMargin = 16;
      if (_this.tooltip.current && _this.tooltipPopover.current) {
        // position the popover top or bottom of the tooltip button depending on space available
        var tooltipPosition = _this.tooltip.current.getBoundingClientRect();
        var availableSpaceAbove = tooltipPosition.top;
        var tooltipPopoverHeight = _this.tooltipPopover.current.clientHeight + defaultMargin;
        var modalSpaceAbove = 0;
        if (_this.props.modalHeaderClassName) {
          var modalHeader = document.querySelector(".".concat(_this.props.modalHeaderClassName));
          if (modalHeader) {
            var modalHeaderPosition = modalHeader.getBoundingClientRect();
            modalSpaceAbove = modalHeaderPosition.bottom;
          }
        }
        var verticalAnchor = tooltipPopoverHeight < availableSpaceAbove - modalSpaceAbove ? 'top' : 'bottom';
        _this.setState({
          verticalAnchor: _this.props.verticalAnchor || verticalAnchor
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "pageAreaCheck", function (e) {
      if (_this.tooltipPopover.current) {
        if (!(0, _detectTouchPoint["default"])(_this.tooltipPopover.current, e)) {
          _this.onPopOverClose(e);
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "windowClickListener", function (event) {
      if (_this.tooltip && !_this.tooltip.current.contains(event.target)) {
        _this.closeTooltip();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "windowEscapeListener", function (event) {
      if (_this.tooltip && event.key === 'Escape') {
        _this.closeTooltip(true);
      }
    });
    _this.state = {
      contentOpen: _this.props.showContent,
      verticalAnchor: props.verticalAnchor || 'top'
    };
    _this.tooltip = /*#__PURE__*/_react["default"].createRef();
    _this.tooltipPopover = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  _createClass(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.state.contentOpen) {
        this.positionTooltipPopover();
        this.props.onOpen();
        if (_env["default"].isClient) {
          window.addEventListener('click', this.windowClickListener);
          window.addEventListener('keydown', this.windowEscapeListener);
        }
      }
      if (_env["default"].isClient) {
        window.addEventListener('resize', this.positionTooltipPopover);
        window.addEventListener('touchstart', this.pageAreaCheck);
        window.addEventListener(TOOLTIP_OPENED_EVENT_NAME, this.onOpen);
        this.initIntersectionObserver();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_prevProps, prevState) {
      if (!prevState.contentOpen && this.state.contentOpen) {
        this.positionTooltipPopover();
        this.props.onOpen();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (_env["default"].isClient) {
        window.removeEventListener('click', this.windowClickListener);
        window.removeEventListener('resize', this.positionTooltipPopover);
        window.removeEventListener('touchstart', this.pageAreaCheck);
        window.removeEventListener('keydown', this.windowEscapeListener);
        window.removeEventListener(TOOLTIP_OPENED_EVENT_NAME, this.onOpen);
        this.removeIntersectionObserver();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        buttonLabel = _this$props.buttonLabel,
        anchor = _this$props.anchor,
        dataTest = _this$props['data-test'],
        icon = _this$props.icon,
        popoverClassname = _this$props.popoverClassname,
        ariaLabel = _this$props.ariaLabel,
        ariaDescribedBy = _this$props.ariaDescribedBy;
      var _this$state = this.state,
        contentOpen = _this$state.contentOpen,
        verticalAnchor = _this$state.verticalAnchor;
      var showIcon = icon || buttonLabel === '';
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        ref: this.tooltip,
        role: "tooltip",
        "aria-label": ariaLabel,
        className: (0, _classnames["default"])(_tooltipModule["default"]['c-tooltip'], _tooltipModule["default"]['joyfully-bold'], _defineProperty(_defineProperty({}, _tooltipModule["default"]['c-tooltip--under'], verticalAnchor === 'bottom'), _tooltipModule["default"]['c-tooltip--open'], contentOpen)),
        "data-test": dataTest,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
          "aria-label": "tooltip",
          "aria-describedby": ariaDescribedBy,
          onClick: this.onClick,
          onTouchStart: this.onButtonTouchStart,
          onTouchEnd: this.onButtonTouchEnd,
          className: (0, _classnames["default"])(_tooltipModule["default"]['c-tooltip__button'], _defineProperty({}, _tooltipModule["default"]['c-tooltip__button--with-icon'], showIcon)),
          type: "button",
          children: [buttonLabel && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            children: buttonLabel
          }), showIcon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Help32PxOutlined["default"], {})]
        }), contentOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: (0, _classnames["default"])(_tooltipModule["default"]['c-tooltip-popover'], _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _tooltipModule["default"]['c-tooltip-popover--top'], verticalAnchor === 'top'), _tooltipModule["default"]['c-tooltip-popover--bottom'], verticalAnchor === 'bottom'), _tooltipModule["default"]['c-tooltip-popover--left'], anchor === 'left'), _tooltipModule["default"]['c-tooltip-popover--right'], anchor === 'right'), _tooltipModule["default"]['c-tooltip-popover--center'], anchor === 'center'), _tooltipModule["default"]['c-tooltip-popover--with-icon'], showIcon), _tooltipModule["default"]['c-tooltip-popover--with-label'], buttonLabel)),
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            ref: this.tooltipPopover,
            className: (0, _classnames["default"])(popoverClassname, _tooltipModule["default"]['c-tooltip-popover__inner']),
            "data-test": "tooltip-popover-inner",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
              onClick: this.onPopOverClose,
              className: _tooltipModule["default"]['c-tooltip-popover__closeButton'],
              "data-test": "tooltip-popover-close-button",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: _tooltipModule["default"]['c-tooltip-popover__closeButtonText'],
                children: "Close information"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: (0, _classnames["default"])(_tooltipModule["default"]['c-tooltip-popover__closeButtonIcon'], _tooltipModule["default"]['joyfully-bold-popover']),
                "data-test": "tooltip-icon"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: _tooltipModule["default"]['c-tooltip-popover__content'],
              "data-test": "tooltip-popover-content",
              role: "alert",
              children: children
            })]
          })
        })]
      });
    }
  }]);
  return Tooltip;
}(_react.PureComponent);
_defineProperty(Tooltip, "propTypes", {
  /** Optional display tooltip popover when component mounts */
  showContent: _propTypes["default"].bool,
  /** Optional popover class name */
  popoverClassname: _propTypes["default"].string,
  /** Contents of the tooltip popover */
  children: _propTypes["default"].node.isRequired,
  /** required to hide active tooltips when there's multiple on screen */
  id: _propTypes["default"].string.isRequired,
  /** label of the tooltip button */
  buttonLabel: _staticContentPropCheck["default"],
  /** Align tooltip popover to `left` || `center` || `right` */
  anchor: _propTypes["default"].oneOf(['left', 'center', 'right']),
  /** Vertical Align tooltip popover to `top` || `bottom` */
  verticalAnchor: _propTypes["default"].oneOf(['top', 'bottom', '']),
  /** labelling attribute for testing purposes */
  'data-test': _propTypes["default"].string,
  /** display an optional "Info" icon */
  icon: _propTypes["default"].bool,
  /** class of modal that tooltip is displayed in */
  modalHeaderClassName: _propTypes["default"].string,
  /** callback triggered when the tooltip opens */
  onOpen: _propTypes["default"].func,
  /** callback triggered when the tooltip closes - it is passed a boolean with value true if the tooltip was manually closed by clicking the cross icon on it, otherwise false */
  onClose: _propTypes["default"].func,
  /** The aria label for the tooltip */
  ariaLabel: _propTypes["default"].string,
  /** The id of the element that describes the tooltip trigger element */
  ariaDescribedBy: _propTypes["default"].string
});
_defineProperty(Tooltip, "defaultProps", {
  showContent: false,
  popoverClassname: undefined,
  id: 'tooltipID',
  buttonLabel: '',
  anchor: 'center',
  verticalAnchor: '',
  'data-test': '',
  icon: false,
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  ariaLabel: undefined,
  ariaDescribedBy: undefined,
  modalHeaderClassName: ''
});
var _default = exports["default"] = Tooltip;